import './_scss/main.scss';
import jQuery from "jquery";

import ImgCompare from './img_compare';

/**
 * Creates jQuery plugin around the Img Compare class
 */
export default (($) => {
    $.fn.ca_img_compare_o_matic_2000 = function mainFunction(options) {
        this.each(function() {
            new ImgCompare($(this), options);
        });
    }
})(jQuery);
